var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaImmigration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00009 15.9998C9.5729 15.9998 10.3787 14.4506 10.4799 12H7.51978C7.62149 14.4511 8.42728 15.9998 9.00009 15.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55054 11.0001H6.51038C6.5657 9.63794 6.84695 8.28372 7.33538 7.32794C5.82741 7.93169 4.73851 9.3281 4.55054 11.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.665 7.32751C11.1535 8.2833 11.4347 9.63798 11.49 10.9997H13.4499C13.2614 9.32814 12.1725 7.93173 10.665 7.32751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00011 6.99982C8.4273 6.99982 7.62151 8.54904 7.52026 10.9997H10.4804C10.3787 8.54904 9.57292 6.99982 9.00011 6.99982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55054 12C4.73851 13.6716 5.82741 15.0684 7.33538 15.6722C6.84695 14.7164 6.5657 13.3617 6.51038 12H4.55054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.99893H15V1.9644C15 0.71565 13.822 -0.260288 12.5531 0.0603369L1.88578 3.01065C0.836719 3.07112 0 3.93502 0 4.99909V21.9992C0 23.1022 0.897187 23.9989 2.00016 23.9989H16.0003C17.1033 23.9989 18.0005 23.1017 18.0005 21.9988V4.99909C18 3.89612 17.1028 2.99893 15.9998 2.99893ZM12.81 1.0269C13.3936 0.877837 14.0002 1.35081 14.0002 1.9644V2.99893H5.67984L12.81 1.0269ZM11.4998 20.9989H6C5.72344 20.9989 5.49984 20.7753 5.49984 20.4988C5.49984 20.2222 5.72344 19.9986 6 19.9986H11.4998C11.7764 19.9986 12 20.2222 12 20.4988C12 20.7753 11.7764 20.9989 11.4998 20.9989ZM13.5 18.9992H3.99984C3.72328 18.9992 3.49969 18.7757 3.49969 18.4991C3.49969 18.2225 3.72328 17.9989 3.99984 17.9989H13.5C13.7766 17.9989 14.0002 18.2225 14.0002 18.4991C14.0002 18.7757 13.7766 18.9992 13.5 18.9992ZM9 16.9991C5.96719 16.9991 3.50016 14.5316 3.50016 11.4992C3.50016 8.4669 5.96719 5.99893 9 5.99893C12.0328 5.99893 14.4998 8.46643 14.4998 11.4988C14.4998 14.5311 12.0328 16.9991 9 16.9991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.665 15.6722C12.173 15.0684 13.2614 13.6716 13.4499 12H11.49C11.4343 13.3622 11.153 14.7164 10.665 15.6722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaImmigration);
export default __webpack_public_path__ + "static/media/visa-immigration.cbb54ece.svg";
export { ForwardRef as ReactComponent };